// src/redux/filter.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import useJwt from '@src/auth/jwt/useJwt';

export const fetchFilteredData = createAsyncThunk(
  'filter/fetchFilteredData',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await useJwt.filterData(filters);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  filters: {
    practice: null,
    provider: null,
    status: null,
    application_types:null,
    state_id: null,
    date: null
  },
  isLoading: false,
  error: null,
  filteredData: null // Optional: if you want to store the API response
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilteredData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFilteredData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filteredData = action.payload; // Store the API response if needed
      })
      .addCase(fetchFilteredData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { setFilters, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;